var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-content pt-4",class:{
    'mt-10': _vm.$vuetify.breakpoint.xs,
    'mt-n3': _vm.$vuetify.breakpoint.sm,
  }},[_c('hb-header',{attrs:{"full":""}},[_c('hb-page-header',{attrs:{"title":"BI Reports"}})],1),_c('div',{staticStyle:{"flex":"1"}},[_c('ReportViewerV2',{attrs:{"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }